function SkeletonButton() {
  return (
    <div className="flex w-full animate-pulse items-center justify-center gap-4 rounded-md border border-[rgba(199,155,242,0.1)] bg-[rgba(199,155,242,0.05)] px-5 py-2.5">
      <div className="h-5 w-5 shrink-0 rounded bg-[rgba(199,155,242,0.1)]" />
      <div className="h-4 w-48 rounded bg-[rgba(199,155,242,0.1)]" />
    </div>
  )
}

export default function SocialLoginSkeleton({ count = 3 }: { count?: number }) {
  return (
    <div className="flex w-full flex-col gap-4">
      {Array.from({ length: count }, (_, i) => (
        <SkeletonButton key={i} />
      ))}
    </div>
  )
}
